import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** DNA validator: writing phrase appears in runtime output from buildNormalizedDay + pilot utils. */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "לשים לב לתנאי",
    opening: localizedGenderNode(
      [
      "היום אני לא מנסה לשנות.",
      "אני רק שם/ה לב לתנאי שאני חי/ה איתו.",
      "זה מספיק לרגע."
    ],
      [
      "היום אני לא מנסה לשנות.",
      "אני רק שם/ה לב לתנאי שאני חי/ה איתו.",
      "זה מספיק לרגע."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מתי אני מרגיש/ה שטוב לי רק אם אני מצליח/ה?",
      "מה קורה סביבי אז?",
      "איך זה מרגיש בגוף שלי?"
    ],
      [
      "מתי אני מרגיש/ה שטוב לי רק אם אני מצליח/ה?",
      "מה קורה סביבי אז?",
      "איך זה מרגיש בגוף שלי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "לשים לב לתנאי הוא כבר התחלה."
    ],
      [
      "לשים לב לתנאי הוא כבר התחלה."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת עם המילים \"אני כאן\".",
      "נשימה אחת עם המילים \"אני כאן\"."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "מאיפה זה בא",
    opening: localizedGenderNode(
      [
      "היום אני שם/ה לב מאיפה התנאי הגיע.",
      "בלי האשמה.",
      "רק לראות."
    ],
      [
      "היום אני שם/ה לב מאיפה התנאי הגיע.",
      "בלי האשמה.",
      "רק לראות."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת לאט.",
      "אני מרגיש/ה את החזה."
    ],
      [
      "אני נושם/ת לאט.",
      "אני מרגיש/ה את החזה."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מתי שמעתי את המסר הזה לראשונה?",
      "מי או מה חיזק אותו?",
      "מה זה עשה לי אז?"
    ],
      [
      "מתי שמעתי את המסר הזה לראשונה?",
      "מי או מה חיזק אותו?",
      "מה זה עשה לי אז?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "לראות את המקור מרכך את ההווה."
    ],
      [
      "לראות את המקור מרכך את ההווה."
    ]
    ),
    action: localizedGenderNode(
      "לכתוב מילה אחת על המקור.",
      "לכתוב מילה אחת על המקור."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "מה אני מנסה להוכיח",
    opening: localizedGenderNode(
      [
      "היום אני שואל/ת מה אני מנסה להוכיח.",
      "לא ביקורת.",
      "סקרנות."
    ],
      [
      "היום אני שואל/ת מה אני מנסה להוכיח.",
      "לא ביקורת.",
      "סקרנות."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה אני מנסה להוכיח כשאני מצליח/ה?",
      "למי אני מנסה להראות?",
      "מה הייתי רוצה שיראו בי בלי הישגים?"
    ],
      [
      "מה אני מנסה להוכיח כשאני מצליח/ה?",
      "למי אני מנסה להראות?",
      "מה הייתי רוצה שיראו בי בלי הישגים?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "להוכיח הוא לפעמים ניסיון לקבל אהבה."
    ],
      [
      "להוכיח הוא לפעמים ניסיון לקבל אהבה."
    ]
    ),
    action: localizedGenderNode(
      "לכתוב אמת אחת עליי בלי הישג.",
      "לכתוב אמת אחת עליי בלי הישג."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "החלק שמפחד לטעות",
    opening: localizedGenderNode(
      [
      "היום אני שם/ה לב לחלק שמפחד לטעות.",
      "לא להילחם.",
      "רק להיות איתו."
    ],
      [
      "היום אני שם/ה לב לחלק שמפחד לטעות.",
      "לא להילחם.",
      "רק להיות איתו."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת לאט.",
      "אני מרגיש/ה את הלב."
    ],
      [
      "אני נושם/ת לאט.",
      "אני מרגיש/ה את הלב."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איפה אני מרגיש/ה את הפחד הזה בגוף?",
      "מה הוא בוחר/ת ממני עכשיו?",
      "איך זה מרגיש להיות איתו רגע?"
    ],
      [
      "איפה אני מרגיש/ה את הפחד הזה בגוף?",
      "מה הוא בוחר/ת ממני עכשיו?",
      "איך זה מרגיש להיות איתו רגע?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "להיות איתו לרגע הוא כבר שינוי קטן."
    ],
      [
      "להיות איתו לרגע הוא כבר שינוי קטן."
    ]
    ),
    action: localizedGenderNode(
      "לשים יד על הלב ולנשום.",
      "לשים יד על הלב ולנשום."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "המחיר של התנאי",
    opening: localizedGenderNode(
      [
      "היום אני רואה את המחיר של התנאי.",
      "לא להאשים.",
      "רק לראות."
    ],
      [
      "היום אני רואה את המחיר של התנאי.",
      "לא להאשים.",
      "רק לראות."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה המחיר שאני משלם/ת על התנאי הזה?",
      "מה אני מפסיד/ה בדרך?",
      "מה הייתי רוצה שיהיה אחרת?"
    ],
      [
      "מה המחיר שאני משלם/ת על התנאי הזה?",
      "מה אני מפסיד/ה בדרך?",
      "מה הייתי רוצה שיהיה אחרת?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "לראות את המחיר פותח מקום לשינוי קטן."
    ],
      [
      "לראות את המחיר פותח מקום לשינוי קטן."
    ]
    ),
    action: localizedGenderNode(
      "לכתוב מילה אחת על המחיר.",
      "לכתוב מילה אחת על המחיר."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "לבקש רוך",
    opening: localizedGenderNode(
      [
      "היום אני מנסח/ת בקשה קטנה לרוך.",
      "לא גדולה.",
      "רק קטנה."
    ],
      [
      "היום אני מנסח/ת בקשה קטנה לרוך.",
      "לא גדולה.",
      "רק קטנה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת.",
      "אני כאן."
    ],
      [
      "אני נושם/ת.",
      "אני כאן."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איך הייתי רוצה שידברו אליי כשאני טועה?",
      "איך אני יכול/ה לדבר ככה לעצמי?",
      "מה צעד קטן בכיוון?"
    ],
      [
      "איך הייתי רוצה שידברו אליי כשאני טועה?",
      "איך אני יכול/ה לדבר ככה לעצמי?",
      "מה צעד קטן בכיוון?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "רוך קטן יכול לפתוח נשימה."
    ],
      [
      "רוך קטן יכול לפתוח נשימה."
    ]
    ),
    action: localizedGenderNode(
      "משפט אחד רך לעצמי.",
      "משפט אחד רך לעצמי."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "להיות שווה גם בלי",
    opening: localizedGenderNode(
      [
      "היום אני בודק/ת איך זה להיות שווה גם בלי הישג.",
      "רק רגע.",
      "לא יותר."
    ],
      [
      "היום אני בודק/ת איך זה להיות שווה גם בלי הישג.",
      "רק רגע.",
      "לא יותר."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה בי טוב גם בלי הצלחות?",
      "איך זה מרגיש לומר את זה?",
      "מה אני מפחד/ת שיקרה אם אאמין בזה?"
    ],
      [
      "מה בי טוב גם בלי הצלחות?",
      "איך זה מרגיש לומר את זה?",
      "מה אני מפחד/ת שיקרה אם אאמין בזה?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "מילה טובה אחת יכולה להיות עוגן."
    ],
      [
      "מילה טובה אחת יכולה להיות עוגן."
    ]
    ),
    action: localizedGenderNode(
      "לומר מילה טובה אחת עליי.",
      "לומר מילה טובה אחת עליי."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "גבול מול דרישה",
    opening: localizedGenderNode(
      [
      "היום אני בודק/ת גבול קטן מול דרישות.",
      "לא להתרחק.",
      "רק לשמור."
    ],
      [
      "היום אני בודק/ת גבול קטן מול דרישות.",
      "לא להתרחק.",
      "רק לשמור."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת לאט.",
      "אני מרגיש/ה את הכתפיים."
    ],
      [
      "אני נושם/ת לאט.",
      "אני מרגיש/ה את הכתפיים."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איפה הדרישה הכי חזקה עליי?",
      "איזה גבול קטן יקל עליי?",
      "איך אני יכול/ה לומר אותו לעצמי?"
    ],
      [
      "איפה הדרישה הכי חזקה עליי?",
      "איזה גבול קטן יקל עליי?",
      "איך אני יכול/ה לומר אותו לעצמי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "גבול קטן שומר על הלב."
    ],
      [
      "גבול קטן שומר על הלב."
    ]
    ),
    action: localizedGenderNode(
      "משפט גבול אחד לעצמי.",
      "משפט גבול אחד לעצמי."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "לבקש חום",
    opening: localizedGenderNode(
      [
      "היום אני בודק/ת איך לבקש חום.",
      "לא דרמה.",
      "בקשה קטנה."
    ],
      [
      "היום אני בודק/ת איך לבקש חום.",
      "לא דרמה.",
      "בקשה קטנה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איזה חום חסר לי?",
      "איך אפשר לבקש אותו בעדינות?",
      "מה צעד קטן בכיוון?"
    ],
      [
      "איזה חום חסר לי?",
      "איך אפשר לבקש אותו בעדינות?",
      "מה צעד קטן בכיוון?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "בקשה אחת יכולה לרכך."
    ],
      [
      "בקשה אחת יכולה לרכך."
    ]
    ),
    action: localizedGenderNode(
      "לכתוב את הבקשה במשפט אחד.",
      "לכתוב את הבקשה במשפט אחד."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "להישאר עם עצמי",
    opening: localizedGenderNode(
      [
      "היום אני מתרגל/ת להישאר עם עצמי כשאני לא מצליח/ה.",
      "לא לברוח.",
      "רק להיות."
    ],
      [
      "היום אני מתרגל/ת להישאר עם עצמי כשאני לא מצליח/ה.",
      "לא לברוח.",
      "רק להיות."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה עוזר לי להישאר איתי?",
      "מה מוציא אותי מעצמי?",
      "מה יכול לעזור לי לחזור?"
    ],
      [
      "מה עוזר לי להישאר איתי?",
      "מה מוציא אותי מעצמי?",
      "מה יכול לעזור לי לחזור?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "להישאר איתי הוא תיקון קטן."
    ],
      [
      "להישאר איתי הוא תיקון קטן."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת אחרי טעות קטנה.",
      "נשימה אחת אחרי טעות קטנה."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "ערך אחד שאינו הישג",
    opening: localizedGenderNode(
      [
      "היום אני מחפש/ת ערך אחד שאינו הישג.",
      "קטן.",
      "אבל אמיתי."
    ],
      [
      "היום אני מחפש/ת ערך אחד שאינו הישג.",
      "קטן.",
      "אבל אמיתי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איזה ערך נשאר גם בלי הצלחות?",
      "איך הערך הזה נראה ביום רגיל?",
      "מה צעד קטן שיכבד אותו?"
    ],
      [
      "איזה ערך נשאר גם בלי הצלחות?",
      "איך הערך הזה נראה ביום רגיל?",
      "מה צעד קטן שיכבד אותו?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "ערך אחד הוא עוגן."
    ],
      [
      "ערך אחד הוא עוגן."
    ]
    ),
    action: localizedGenderNode(
      "מילה אחת שמבטאת את הערך.",
      "מילה אחת שמבטאת את הערך."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "להקשיב לי",
    opening: localizedGenderNode(
      [
      "היום אני מתרגל/ת להקשיב לי.",
      "גם כשאין הצלחה.",
      "גם אז."
    ],
      [
      "היום אני מתרגל/ת להקשיב לי.",
      "גם כשאין הצלחה.",
      "גם אז."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת לאט.",
      "אני מרגיש/ה את הלב."
    ],
      [
      "אני נושם/ת לאט.",
      "אני מרגיש/ה את הלב."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה אני בוחר/ת/ה לשמוע מעצמי היום?",
      "מה אני נותן/ת לאחרים שאני לא נותן/ת לי?",
      "איך אפשר לתת את זה לעצמי?"
    ],
      [
      "מה אני בוחר/ת/ה לשמוע מעצמי היום?",
      "מה אני נותן/ת לאחרים שאני לא נותן/ת לי?",
      "איך אפשר לתת את זה לעצמי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "להקשיב לי הוא תיקון קטן."
    ],
      [
      "להקשיב לי הוא תיקון קטן."
    ]
    ),
    action: localizedGenderNode(
      "משפט אחד עדין לעצמי.",
      "משפט אחד עדין לעצמי."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "צעד קטן של קבלה",
    opening: localizedGenderNode(
      [
      "היום אני בוחר/ת צעד קטן של קבלה.",
      "בלי דרמה.",
      "צעד קטן."
    ],
      [
      "היום אני בוחר/ת צעד קטן של קבלה.",
      "בלי דרמה.",
      "צעד קטן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה צעד קטן שאני מוכן/ה לנסות?",
      "מה ירגיש לי בטוח מספיק?",
      "איך זה ישמור עליי?"
    ],
      [
      "מה צעד קטן שאני מוכן/ה לנסות?",
      "מה ירגיש לי בטוח מספיק?",
      "איך זה ישמור עליי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "צעד קטן מספיק כדי לזוז."
    ],
      [
      "צעד קטן מספיק כדי לזוז."
    ]
    ),
    action: localizedGenderNode(
      "לבחור צעד אחד קטן ולזכור אותו.",
      "לבחור צעד אחד קטן ולזכור אותו."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "משפט חזרה",
    opening: localizedGenderNode(
      [
      "היום אני בוחר/ת משפט שמחזיר אותי לאהבה שאינה תלויה.",
      "כשאני נופל/ת.",
      "משפט קטן."
    ],
      [
      "היום אני בוחר/ת משפט שמחזיר אותי לאהבה שאינה תלויה.",
      "כשאני נופל/ת.",
      "משפט קטן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת.",
      "אני כאן."
    ],
      [
      "אני נושם/ת.",
      "אני כאן."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה למדתי על התנאי הזה?",
      "מה הסימן הראשון שהוא חוזר?",
      "איזה משפט מחזיר אותי רגע לפני?"
    ],
      [
      "מה למדתי על התנאי הזה?",
      "מה הסימן הראשון שהוא חוזר?",
      "איזה משפט מחזיר אותי רגע לפני?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "אני יכול/ה לטעות ולהישאר עם עצמי."
    ],
      [
      "אני יכול/ה לטעות ולהישאר עם עצמי."
    ]
    ),
    action: localizedGenderNode(
      "לומר את המשפט החדש פעם אחת.",
      "לומר את המשפט החדש פעם אחת."
    ),
  },
].map(buildNormalizedDay);

export const conditionalLoveGoodOnlyIfISucceedBlueprintHe = buildNormalizedPilotBlueprint({
  id: "conditional_love_good_only_if_i_succeed_14d",
  version: "tri_locale_emit_he_v1",
  durationDays: 14,
  problemKey: "conditional_love_good_only_if_i_succeed",
  category: "childhood_parents_past_wounds",
  journeyName: {
    he: "אהבה על תנאי (טוב רק אם אני מצליח/ה)",
    en: "Conditional love (good only if I succeed)",
    es: "Amor condicional (solo soy bueno/a si tengo éxito)",
  },
  days,
});

export default conditionalLoveGoodOnlyIfISucceedBlueprintHe;
